<template>
  <o-form ref="form"
          :title="$t('sandoz.contract')"
          :url="`/api/sandoz/contracts/${$route.params.id}/view`"
          class="ortic-form-horizontal contract-view">
    <template slot-scope="props">
      <b-row>
        <b-col cols="3">
          <o-form-group :label="$t('sandoz.contract_no')" class="d-block">
            <div class="form-control auto-height">
              {{ props.item.contract_no }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('core.name')" class="d-block">
            <div class="form-control auto-height" v-if="props.item.master_address_single">
              {{props.item.master_address_single.salutation ? props.item.master_address_single.salutation : ''}}
              {{props.item.master_address_single.company_name ? props.item.master_address_single.company_name : ''}}
              {{props.item.master_address_single.name ? props.item.master_address_single.name : ''}}
              {{props.item.master_address_single.last_name ? props.item.master_address_single.last_name : ''}}
            </div>
          </o-form-group>
        </b-col>
        <b-col>
          <o-form-group :label="$t('sandoz.vendor_no')" class="d-block">
            <div class="form-control auto-height">
              {{ props.item.customer_no_vendor ? props.item.customer_no_vendor : '-' }}
            </div>
          </o-form-group>
          <o-form-group :label="$t('sandoz.address')" class="d-block">
            <div class="form-control auto-height">
              {{ props.item.master_address_single ?
                props.item.master_address_single.street + ', ' +
                props.item.master_address_single.zip + ', ' +
                props.item.master_address_single.city
                : null
              }}
            </div>
          </o-form-group>
        </b-col>
        <b-col cols="4">
          <o-form-group :label="$t('sandoz.approvals')" class="d-block">
            <template v-for="i in 6">
              <div v-if="props.item['approver_' + i] && props.item['approval_date_' + i] && props.item['approval_person_' + i]"
                   class="form-control auto-height mb-2">
                {{ props.item['approver_' + i] }}, {{ props.item['approval_person_' + i] }},
                {{ props.item['approval_date_' + i] | formatDate }}
              </div>
            </template>
          </o-form-group>
        </b-col>
        <b-col>
          <o-form-group :label="$t('sandoz.cp_login_list')" class="d-block" v-if="props.item.logins && props.item.logins.length > 0">
            <div v-for="login in props.item.logins" class="form-control" :key="login.email">
              <fa icon="check" class="text-success" v-if="!!login.agreed_to_terms" />
              <fa icon="times" class="text-danger" v-else/>
              {{ login.email }}
            </div>
          </o-form-group>

          <div>
            <o-button type="button" v-if="props.item.latest_pdf" variant="primary" class="mb-1" @click.prevent="download(0)">
              <fa icon="file-pdf"/> {{ $t('sandoz.download_contract_pdf') }}
            </o-button>

            <o-button v-if="props.item.latest_import_job" @click.prevent="downloadExcel(props.item)">
              <fa icon="file-excel"/> {{ $t('sandoz.download_contract_excel') }}
            </o-button>

            <button @click="openLink(props.item.file_link_1)" class="btn btn-primary" v-if="props.item.file_link_1">
              <fa icon="link" class="mr-1 d-inline mt-1"/>
              {{ $t('sandoz.file_link_1') }}
            </button>
            <button @click="openLink(props.item.file_link_2)"  class="btn btn-primary" v-if="props.item.file_link_2">
              <fa icon="link" class="mr-1 d-inline mt-1"/>
              {{ $t('sandoz.file_link_2') }}
            </button>
            <button @click="openLink(props.item.file_link_3)"  class="btn btn-primary" v-if="props.item.file_link_3">
              <fa icon="link" class="mr-1 d-inline mt-1"/>
              {{ $t('sandoz.file_link_3') }}
            </button>

            <b-dropdown v-if="props.item.word_files && props.item.word_files.length"
                        :text="$t('sandoz.supporting_files') + ' (' + props.item.word_files.length + ')'"
                        variant="primary" class="mb-1">
              <b-dropdown-item v-for="(file, i) in props.item.word_files" :key="file.id" href="#"
                               @click.prevent="wordDownload(i)">
                <fa icon="file" class="mr-1"/>
                {{ file.file_name ? file.file_name.name : null }}
              </b-dropdown-item>
            </b-dropdown>

          </div>
          <o-form-group :label="$t('sandoz.sales_rep_comment')" class="d-block mt-2" v-if="props.item.sales_rep_comment">
            <div class="form-control auto-height" style="white-space: pre-wrap;">{{ props.item.sales_rep_comment }}</div>
          </o-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <div class="card">
            <div class="card-header px-0 pt-4 pb-3 row">
              <div class="col text-left small">{{ $t('sandoz.cp_invoices') }}
                <span class="total">({{$t('sandoz.total_without_vat')}} {{ invoiced(props.item.invoices) | formatNumber }})</span>
              </div>
            </div>
            <div class="table-responsive table-bordered">
              <table class="table table-sm">
                <thead>
                <tr>
                  <th>{{$t('sandoz.no')}}</th>
                  <th>{{$t('sandoz.date')}}</th>
                  <th>{{$t('sandoz.amount_without_vat')}}</th>
                  <th class="text-right"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(invoice, i) in props.item.invoices">
                  <tr>
                    <td>{{invoice.created_at | formatYear}}-{{invoice.id}}</td>
                    <td>{{invoice.created_at | formatDate}}</td>
                    <td>{{invoice.total | formatNumber}}</td>
                    <td class="text-center text-nowrap">
                      <o-button type="button" variant="primary" @click.prevent="downloadInvoice(invoice)">
                        <fa icon="file-pdf"/>
                      </o-button>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </b-col>
        <b-col>
          <div class="table-responsive table-borderless mt-5">
            <table class="table table-sm">
              <tbody>
              <tr>
                <td>{{$t('sandoz.total_amount_without_vat')}}</td>
                <td>{{ (totalMarketingActivity(props.item.lines) - totalService(props.item.lines)) | formatNumber }}</td>
              </tr>
              <tr>
                <td>{{$t('sandoz.invoiced_without_vat')}}</td>
                <td>{{ invoiced(props.item.invoices) | formatNumber }}</td>
              </tr>
              <tr>
                <td>{{$t('sandoz.open_without_vat')}}</td>
                <td>{{ (totalMarketingActivity(props.item.lines) - totalService(props.item.lines)) - invoiced(props.item.invoices) | formatNumber }}</td>
              </tr>
              <template  v-for="(line, i) in props.item.lines" >
                <tr :key="line.id" v-if="line.product && line.product.product_master && line.product.product_master.hold_actual_amount_of_educational === true">
                  <td>{{ line.product_name }}</td>
                  <td>{{ line.price | formatNumber }}</td>
                </tr>
              </template>
              <tr>
                <td colspan="2">
                  <hr>
                  <o-textarea :errorField="'invoice_payment_information'" :label="$t('sandoz.invoice_payment_information')"
                              v-model="props.item.invoice_payment_information"/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-header px-0 pt-4 pb-3 row">
              <div class="col text-left small">{{ $t('sandoz.marketing_activities') }}
                <span class="total">({{$t('sandoz.total_without_vat')}} {{ totalMarketingActivity(props.item.lines) | formatNumber }})</span>
              </div>
            </div>
            <div class="table-responsive table-bordered">
              <table class="table table-sm">
                <thead>
                <tr>
                  <th>{{$t('sandoz.marketing_activity')}}</th>
                  <th>{{$t('sandoz.planned_verification')}}</th>
                  <th>{{$t('sandoz.quantity')}}</th>
                  <th>{{$t('sandoz.price')}}</th>
                  <th>{{$t('sandoz.address')}}</th>
                  <th>{{$t('sandoz.proof')}}</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(line, i) in props.item.lines">
                  <template v-if="line.deliveries.length && !props.item.type.endsWith('_EDU')">
                    <template v-for="(activity, i) in line.deliveries">
                      <tr v-if="(line.price || line.verification_required === 1 || (line.verifications && Object.keys(line.verifications).length > 0)) && ((line.product && line.product.product_master && line.product.product_master.hold_actual_amount_of_educational === false ) || (!line.product))">
                        <td>{{line.product_name}}</td>
                        <td v-if="line.verifications && Object.keys(line.verifications).length > 0"> {{line.verifications[i].planned_verification | formatDate}}</td>
                        <td v-else></td>
                        <td>{{activity.quantity}}</td>
                        <td>{{line.price | formatNumber}}</td>
                        <td v-if="line.contract_address">{{line.contract_address.company_name}}, {{line.contract_address.street}}, {{line.contract_address.zip}} {{ line.contract_address.city }}</td>
                        <td v-else></td>
                        <td v-if="line.verifications && Object.keys(line.verifications).length > 0">
                          <template v-if="line.verifications[i].status === 'verified'">
                              {{ line.verifications[i].actual_verification | formatDate }}
                          </template>
                          <template v-else>
                            {{ line.verifications[i].status }}
                          </template>
                          <a href="#" @click="setPictures(line.verifications[i].pictures[0])" v-if="props.item.contract_year <= 2024 && line.verifications[i].pictures && line.verifications[i].pictures.length > 0">
                            <fa icon="camera"/>
                          </a>
                          <!-- path: '/sandoz/verifications/'+line.verifications[0].id  -->
                          <router-link :to="{ path: '/sandoz/verifications/'+line.verifications[i].id}" class="ml-1 mt-2" v-if="activity.product_name !== 'Sortimentsanalyse'">
                            <fa icon="eye"/>
                          </router-link >
                          <router-link :to="{ path: '/sandoz_sortalys/bezugsstatistik?external_id='+props.item.customer_external_id}" class="ml-1 mt-2" v-else>
                            <fa icon="eye"/>
                          </router-link >
                        </td>
                        <td v-else-if="props.item.kam_verification_lines && Object.keys(props.item.kam_verification_lines).length > 0">
                            <template v-if="props.item.kam_verification_lines[0].verifications && Object.keys(props.item.kam_verification_lines[0].verifications).length > 0">
                              {{ props.item.kam_verification_lines[0].verifications.actual_verification | formatDate }}
                            </template>
                        </td>
                        <td v-else>-</td>
                      </tr>
                    </template>
                  </template>

                  <template v-else-if="props.item.type.endsWith('_EDU') && ((line.product && line.product.product_master && line.product.product_master.hold_actual_amount_of_educational === false) || (!line.product))">
                    <tr>
                        <td>{{line.product_name}}</td>
                        <td v-if="line.verifications && Object.keys(line.verifications).length > 0"> {{line.verifications[0].planned_verification | formatDate}}</td>
                        <td v-else></td>
                        <td>1</td>
                        <td>{{line.price | formatNumber}}</td>
                        <td v-if="line.contract_address">{{line.contract_address.company_name}}, {{line.contract_address.street}}, {{line.contract_address.zip}} {{ line.contract_address.city }}</td>
                        <td v-else></td>

                        <td v-if="line.verifications && Object.keys(line.verifications).length > 0">
                          {{  line.verifications[0].status }}
                          <template v-if="line.verifications[0].status === 'verified'">
                              {{ line.verifications[0].actual_verification | formatDate }}
                          </template>
                          <template v-else>
                            {{ line.verifications[0].status }}
                          </template>
                          <a href="#" @click="setPictures(line.verifications[0].pictures[0])" v-if="props.item.contract_year <= 2024 && line.verifications[0].pictures && line.verifications[0].pictures.length > 0">
                            <fa icon="camera"/>
                          </a>
                          <!-- path: '/sandoz/verifications/'+line.verifications[0].id  -->
                          <router-link :to="{ path: '/sandoz/verifications/'+line.verifications[0].id}" class="ml-1 mt-2" v-if="line.product_name !== 'Sortimentsanalyse'">
                            <fa icon="eye"/>
                          </router-link >
                        </td>
                        <td v-else>-</td>
                      </tr>
                  </template>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-header px-0 pt-4 pb-3 row">
              <div class="col text-left small">{{ $t('sandoz.services') }}
                <span class="total">({{$t('sandoz.total')}} {{ totalService(props.item.lines) | formatNumber }})</span>
              </div>
            </div>
            <div class="table-responsive table-bordered">
              <table class="table table-sm">
                <thead>
                <tr>
                  <th>{{$t('sandoz.service')}}</th>
                  <th>{{$t('sandoz.quantity')}}</th>
                  <th>{{$t('sandoz.price')}}</th>
                  <th>{{$t('sandoz.address')}}</th>
                  <th>{{$t('sandoz.executed')}}</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(line, i) in props.item.lines">
                  <template v-for="(activity, i) in line.invoice_services">
                    <tr v-if="line.invoice_services && Object.keys(line.invoice_services).length > 0">
                      <td>{{activity.product_name}}</td>
                      <td>{{activity.quantity}}</td>
                      <td>{{line.price | formatNumber}}</td>
                      <td>{{activity.address}}</td>
                      <td v-if="line.pending_deliveries && Object.keys(line.pending_deliveries).length > 0">
                        <fa icon="times"/>
                      </td>
                      <td v-else>
                        <fa icon="check"/>
                      </td>
                    </tr>
                  </template>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
  </o-form>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    i: null
  }),
  methods: {
    download (i = null) {
      if (i !== null) {
        let pdf = this.$refs.form.item.latest_pdf
        axios.post('/api/sandoz/contract_pdfs/download', {
          'id': pdf.id
        }, { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(response.data,
              pdf.file_name + '.pdf', 'application/pdf'
            )
          }).catch((error) => {
            console.log(error)
          })
      }
    },
    wordDownload (i) {
      if (i !== null) {
        const file = this.$refs.form.item.word_files[i]
        axios.post('/api/sandoz/contract_word_file/download', {
          'id': file.id
        }, {responseType: 'arraybuffer'})
          .then((response) => {
            require('downloadjs')(
              response.data,
              file.file_name.name,
              'application/octet-stream'
            )
          }).catch((error) => {
          console.log(error)
        })
      }
    },
    openLink (link) {
      window.open(link, '_blank')
    },
    downloadExcel(item) {
      axios.post('/api/sandoz/import_jobs/download', { 'id': item.latest_import_job.id }, { responseType: 'arraybuffer' })
        .then((response) => {
          require('downloadjs')(response.data, item.latest_import_job.file_name, 'application/vnd.ms-excel')
        }).catch((error) => {
          self.$notify({
            title: self.$i18n.t('core.error_alert_title'),
            text: self.$i18n.t('core.error_alert_text'),
            type: 'error'
          })
        })
    },
    downloadInvoice(invoice) {
      axios.post('/api/sandoz/contract_invoice_pdfs/download', {
        'id': invoice.id
      }, { responseType: 'arraybuffer' })
        .then((response) => {
          require('downloadjs')(response.data,
            'invoice_' + invoice.id + '.pdf', 'application/pdf'
          )
        }).catch((error) => {
          console.log(error)
        })
    },
    xlsx (i) {
      if (i !== null) {
        let file = this.$refs.form.item.import_jobs[i]
        axios.post('/api/sandoz/import_jobs/download', {
          'id': file.id
        }, { responseType: 'arraybuffer' })
          .then((response) => {
            require('downloadjs')(response.data,
              file.file_name, 'application/vnd.ms-excel'
            )
          }).catch((error) => {
            console.log(error)
          })
      }
    },
    invoiceTotal (invoices) {
      let total = 0

      if (!invoices || (invoices && Object.keys(invoices).length <= 0)) {
        return total
      }

      invoices.forEach((invoice) => {
        if (invoice.status === 'invoiced' || invoice.status === 'pending') {
          total += parseFloat(invoice.total)
        }
      })
      return total
    },
    invoiced (invoices) {
      let total = 0

      if (!invoices || (invoices && Object.keys(invoices).length <= 0)) {
        return total
      }

      invoices.forEach((invoice) => {
        if (invoice.status === 'invoiced' || invoice.status === 'pending') {
          total += parseFloat(invoice.total)
        }
      })
      return total
    },
    totalMarketingActivity (lines) {
      let total = 0

      if (!lines || (lines && Object.keys(lines).length <= 0)) {
        return total
      }

      lines.forEach((line) => {
        if (line.deliveries && Object.keys(line.deliveries).length > 0) {
          if (line.price && !line.verification_required) {
            total += parseFloat(line.price)
          }
        }
      })
      return total
    },
    totalService (lines) {
      let total = 0

      if (!lines || (lines && Object.keys(lines).length <= 0)) {
        return total
      }

      lines.forEach((line) => {
        if (line.invoice_services && Object.keys(line.invoice_services).length > 0) {
          if (line.price) {
            total += parseFloat(line.price)
          }
        }
      })
      return total
    },
    setPictures(picture) {
      if (picture) {
        var src = '/verifications/' + picture.contract_line_verification_id + '/' + picture.picture;
        window.open(src, '_blank')
      }
    }
  }
}
</script>

<style>
 .total {
   text-transform: none;
 }
</style>
